package xim.poc.game.event

import xim.poc.ActorId
import xim.poc.game.ActorStateManager
import xim.poc.game.AttackContext
import xim.poc.game.StatusEffectState
import xim.poc.ui.ChatLog

class ActorGainStatusEvent(
    val sourceId: ActorId,
    val targetId: ActorId,
    val statusState: StatusEffectState,
    val context: AttackContext,
): Event {

    override fun apply(): List<Event> {
        val targetState = ActorStateManager[targetId] ?: return emptyList()

        val newStatusState = StatusEffectState(statusState.statusEffect)
        newStatusState.copyFrom(statusState)
        newStatusState.sourceId = sourceId

        targetState.gainStatusEffect(statusState)

        AttackContext.compose(context) { ChatLog.statusEffectGained(targetState.name, statusState.statusEffect, context) }

        return emptyList()
    }

}